export enum ActionType {
    REQUEST_FILTER = '[DASHBOARD/FLEET-SCORE-OVER-TIME-CONTEXT] REQUEST FILTER',
    RECEIVE_PREFS_FILTER = '[DASHBOARD/FLEET-SCORE-OVER-TIME-CONTEXT] RECEIVE PREFS FILTER',
    SHOW_FILTER = '[DASHBOARD/FLEET-SCORE-OVER-TIME-CONTEXT] RECEIVE FILTER',
    SET_SEARCH_VESSEL_TAG_TERM = '[DASHBOARD/FLEET-SCORE-OVER-TIME-CONTEXT] SET SEARCH VESSEL TAG TERM',
}
